module.exports = "/images/flag-id.svg?9c1373e44f8e1f39046c14c55dd43b38";